import React, { useState, useEffect } from 'react'
import { Box, Flex, Button, Text, TextInput, Input } from '@mantine/core'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { addDiscussion, updateDiscussion } from '../../../../services/discussion'
import { 
  ClassicEditor, 
  Bold, 
  Essentials, 
  Italic, 
  Mention, 
  Paragraph, 
  Undo, 
  Font, 
  Heading,
  Image,
  ImageCaption,
  ImageResizeEditing, 
  ImageResizeHandles,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  ImageInline,
  ImageBlock,
  LinkImage,
  ImageUpload,
  ImageInsertViaUrl,
  List,
  MediaEmbed,
  Alignment
} from 'ckeditor5'
import { validation } from '../../../../plugins/validation'
import { useParams } from 'react-router-dom'
// import { useSelector } from 'react-redux'
import { notificationSuccess, notificationError } from '../../../ui/Notification'

const defaultVal = {
  title: '',
  content: '',
}

const formValidation = {
  title: {
    isError: false,
    message: ''
  },
  content: {
    isError: false,
    message: ''
  },
}

const FormDiscussionProgram = ({ detail, cancelAddQuestion, handleReload }) => {
  const params = useParams()
  const programId = params.id
  // const dataMember = useSelector(state => state.member.data)
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return uploadAdapter(loader)
    }
  }

  const uploadAdapter = (loader) => {
    return {
      upload: async () => {
        const file = await loader.file
        const base64 = await toBase64(file)
        return {
          default: base64
        }
      },
    }
  }

  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

  const configEditor = {
    licenseKey: 'GPL',
    extraPlugins: [ uploadPlugin ],
    plugins:[
      Bold,
      Essentials,
      Italic,
      Mention,
      Paragraph,
      Undo,
      Font,
      Heading,
      Image,
      ImageCaption,
      ImageResize,
      ImageStyle,
      ImageToolbar,
      ImageInline,
      ImageBlock,
      LinkImage,
      ImageUpload,
      ImageResizeEditing, 
      ImageResizeHandles,
      ImageInsertViaUrl,
      List,
      MediaEmbed,
      Alignment
    ],
    alignment: {
      options: [ 'left', 'right' ]
    },
    fontSize: {
      options: [
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22
      ],
      supportAllValues: true
    },
    image: {
      resizeUnit: "%",
			resizeOptions: [
        {
            name: 'resizeImage:original',
            value: null,
            label: 'Original'
        },
        {
            name: 'resizeImage:custom',
            label: 'Custom',
            value: 'custom'
        },
        {
            name: 'resizeImage:40',
            value: '40',
            label: '40%'
        },
        {
            name: 'resizeImage:60',
            value: '60',
            label: '60%'
        }
      ],
      toolbar: [
        'resizeImage',
        '|',
        'imageStyle:alignBlockLeft',
        'imageStyle:alignBlockRight',
        '|',
        'imageStyle:alignCenter',
        '|',
        'imageStyle:alignLeft',
        'imageStyle:alignRight',
        '|',
        'toggleImageCaption',
        'imageTextAlternative',
        '|',
        'linkImage'
      ],
      insert: {
          integrations: [ 'upload', 'url' ]
      }
    },
    list: {
      properties: {
          styles: true,
          startIndex: true,
          reversed: true
      }
    },
    toolbar: {
      items: [
        'undo', 'redo',
        '|',
        'heading',
        '|',
        'fontSize', 'Bold', 'Italic', 'alignment',
        '|',
        'link', 'insertImage',
        '|',
        'mediaEmbed',
        '|',
        'bulletedList', 'numberedList',
        '|',
      ],
      shouldNotGroupWhenFull: true
    },
    initialData: `${formData.content}`
  }

  const submitDiscussion = async () => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''

    const isError = validation(formData, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    if (detail !== null) {
      const updatePayload = {
        title: formData.title,
        content: formData.content
      }
      methodFunction = updateDiscussion(detail.id, updatePayload)
      titleMessageSuccess = 'Update Diskusi Berhasil'
      captionMessageSuccess = 'Anda telah mengupdate diskusi baru'
      titleMessageError = 'Update Diskusi Gagal'
    } else {
      const createPayload = {
        title: formData.title,
        content: formData.content,
        userEventId: programId,
      // curriculumContentId: programId,
      }
      methodFunction = addDiscussion(createPayload)
      titleMessageSuccess = 'Penambahan Diskusi Berhasil'
      captionMessageSuccess = 'Anda telah menambahkan diskusi baru'
      titleMessageError = 'Penambahan Diskusi Gagal'
    }
    try {
      const response = await methodFunction
      if (response) {
        handleReload()
        cancelAddQuestion()
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Silahkan cek kembali form anda'
      notificationError(titleMessageError, captionMessageError)
      Object.values(errorMessage).forEach((el) => {
        Object.keys(formValidation).forEach((element) => {
          if (el.includes(element)) {
            setValidationForm((old) => ({
              ...old,
              [element]: {
                ...old?.[element],
                isError: true,
                message: el
              }
            }))
          }
        })
      })
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (detail !== null) {
      handleSetForm(detail)
    }
    setIsLoaded(true)
    // eslint-disable-next-line
  }, [])

  const handleSetForm = (value) => {
    const data = {
      title: value.title,
      content: value.content
    }
    setFormData(data)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const initCKeditor = () => {
    return (
      <CKEditor
          editor={ClassicEditor}
          config={configEditor}
          data={formData.content}
          onReady={(editor) => {
            editor.execute('fontSize', { value: '12px' })
            editor.editing.view.change((writer) => {
              writer.setStyle(
                'height',
                '300px',
                editor.editing.view.document.getRoot()
              )
            })
          }}
          onChange={( event, editor ) => {
            editor.execute('fontSize', { value: '13px' })
            const valueEditor = editor.getData()
            handleChangeForm('content', valueEditor)
          }}
        />
    )
  }

  return (
    <Box px={40}>
      <Text mb={20} fw='bold'>{detail !== null ? 'Edit' : 'Tambah'} Diskusi</Text>
      <Box>
        <Box mb='md'>
          <TextInput
            name="title"
            value={formData.title}
            placeholder="Isi Judul Diskusi"
            label="Judul Diskusi"
            size='xs'
            error={validationForm.title.isError ? `${validationForm.title.message}` : ''}
            onChange={(val) => handleChangeForm('title', val.target.value)}
            withAsterisk
          />
        </Box>
        <Box mb='md'>
          <Input.Wrapper 
            label="Konten Diskusi"
            withAsterisk
            error={validationForm.content.isError ? `${validationForm.content.message}` : ''}
          >
            {isLoaded ? initCKeditor() : ''}
          </Input.Wrapper>
        </Box>
      </Box>
      <Box mt={14}>
        <Flex justify='flex-end' mb={14}>
          <Button size='xs' mr={6} onClick={cancelAddQuestion}>Batal</Button>
          <Button color='red' loading={loadingForm} size='xs' onClick={() => submitDiscussion()}>{detail !== null ? 'Edit' : 'Tambah'} Diskusi</Button>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormDiscussionProgram